import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { isMeetingItemForPastEvent } from './isMeetingItemForPastEvent';
import { isMeetingRequest } from './isMeetingRequest';
import { MeetingMessageType } from 'mini-calendar-event-services/lib/schema/MeetingMessageType';

// This determines if for a new meeting item we must show the rsvp item
export const shouldLatestMeetingItemShowRsvp = (
    meetingItem: MeetingMessageType,
    effectiveFolderName?: DistinguishedFolderIdName
) => {
    if (!meetingItem.Start || !meetingItem.End || !meetingItem.CalendarItemType) {
        return false;
    }

    const folderName = effectiveFolderName || folderIdToName(meetingItem.ParentFolderId?.Id);

    // Do not show for sent items or deleted items
    if (['deleteditems', 'sentitems'].includes(folderName)) {
        return false;
    }

    // don't show RSVP for delegate scenarios
    if (!!meetingItem.IsDelegated && !!meetingItem.ReceivedRepresenting) {
        return false;
    }

    // AssociatedCalendarItemId is not available if the meeting cancellation
    // has already been delete and user moves it back to non deleted item folder
    if (!meetingItem.AssociatedCalendarItemId) {
        return false;
    }

    // Cases specific for meeting requests
    if (isMeetingRequest(meetingItem.ItemClass)) {
        const meetingRequest = meetingItem as MeetingRequestMessageType;

        // Don't want to show for no response required scenarios
        if (meetingRequest.MeetingRequestType === 'InformationalUpdate') {
            return false;
        }

        // Don't show RSVP if response type is unknown, or organizer or attendee responded
        if (meetingItem.ResponseType && meetingItem.ResponseType !== 'NoResponseReceived') {
            return false;
        }

        // For an eligible past event ( a standalone past event or a recurrence master which has ended ) don't show
        if (isMeetingItemForPastEvent(meetingItem)) {
            return false;
        }
    }

    return true;
};
